import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src562611367/src/src/app/ui/common/side-menu.tsx");
